import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    WinReductionInfo,
    WinReductionRowWrapper,
    WinReductionAmount,
} from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/WinReduction.style';
import { MyBetsTooltip } from 'src/domains/sportsbook/webview/components/myBetsTooltip/MyBetsTooltip';

interface WinReductionPropsType {
    resultWinReduction: string;
}

export const WinReduction = observer('WinReduction', ({ resultWinReduction }: WinReductionPropsType) => {
    return (
        <WinReductionRowWrapper>
            <WinReductionInfo>
                <I18n
                    langKey='bets.selection.WinReduction.label'
                    defaultText='Dead Heat Applied'
                />
                <MyBetsTooltip
                    content={
                        <I18n
                            langKey='bets.summary.WinReduction.text'
                            defaultText='Where selections dead-heat, the stake money is split across the number of selections that dead-heat and paid at full-odds.'
                        />
                    }
                />
            </WinReductionInfo>
            <WinReductionAmount>{resultWinReduction}</WinReductionAmount>
        </WinReductionRowWrapper>
    );
});
